import React from 'react';
import { FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { FiInstagram } from 'react-icons/fi';




const Footer = () => {
  return (
    <footer className="bg-pink-100 bg-cover py-12 text-center text-sm text-light">
      <a href="#home" className="text-dark text-3xl font-bold block mb-4">Romina Molina</a>
      <ul className="flex flex-wrap justify-center gap-8 mb-6">
        <li><a href="#home" className="footer-links">Home</a></li>
        <li><a href="#about" className="footer-links">About</a></li>
        <li><a href="#experience" className="footer-links">Experience</a></li>
        <li><a href="#services" className="footer-links">Services</a></li>
        <li><a href="#portfolio" className="footer-links">Portfolio</a></li>
        <li><a href="#contact" className="footer-links">Contact</a></li>
      </ul>

      <div className="flex justify-center gap-6 mb-6">
        <a href="https://www.facebook.com" target="_blank" rel="noreferrer" className="text-dark text-2xl hover:text-primary">
          <FaFacebook />
        </a>
        <a href="https://www.instagram.com" target="_blank" rel="noreferrer" className="text-dark text-2xl hover:text-primary">
          <FiInstagram />
        </a>
        <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" className="text-dark text-2xl hover:text-primary">
          <FaLinkedin />
        </a>
        <a href="https://www.twitter.com" target="_blank" rel="noreferrer" className="text-dark text-2xl hover:text-primary">
          <FaTwitter />
        </a>
      </div>

      <div className="text-dark">
        <small>&copy; Romina Molina, All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
